import { KeyboardEvent } from 'react';

import { normalizeExp } from './normalizers';

export const handleExpdateEvents = {
  onKeyUp: (event: KeyboardEvent<HTMLInputElement>): void => {
    if (['Backspace', 'Delete'].indexOf(event.key) !== -1) {
      return;
    }

    const { value } = event.target as HTMLInputElement;
    (event.target as HTMLInputElement).value = normalizeExp(value);
  },
};
